import Reveal from '@/components/base/Reveal';
import { testimonials } from '@/mocks/site';

export default function Testimonial() {
  const testimonial = testimonials[0];

  return (
    <section className="relative overflow-hidden bg-background-100 py-20 md:py-24">
      <div className="pointer-events-none absolute inset-0 paper-grid opacity-60" />
      <div className="container-wide relative">
        <Reveal>
          <div className="relative mx-auto max-w-4xl overflow-hidden rounded-lg border border-foreground-950/10 bg-background-50 px-6 py-12 md:px-14 md:py-16">
            <span className="absolute left-0 top-0 h-full w-[3px] bg-accent-500" />
            <span className="pointer-events-none absolute -right-6 -top-10 select-none font-heading text-[10rem] font-semibold leading-none text-foreground-950/5">
              ”
            </span>
            <div className="relative">
              <div className="flex items-center gap-3">
                <span className="h-px w-8 bg-accent-500" />
                <span className="label-mono text-primary-600">Parole de client</span>
              </div>
              <blockquote className="mt-7 font-heading text-2xl font-medium uppercase leading-[1.15] tracking-wide text-foreground-950 md:text-4xl">
                «&nbsp;{testimonial.quote}&nbsp;»
              </blockquote>
              <div className="mt-9 flex items-center gap-4 border-t border-foreground-950/10 pt-6">
                <div className="h-12 w-12 flex-none overflow-hidden rounded-full bg-background-300 ring-1 ring-foreground-950/10">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    title={`Témoignage client — ${testimonial.name}`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{testimonial.name}</p>
                  <p className="text-xs uppercase tracking-[0.16em] text-foreground-500">
                    {testimonial.role}
                  </p>
                </div>
                <span className="ml-auto hidden h-8 w-8 flex-none items-center justify-center rounded-sm bg-primary-500 text-background-50 sm:flex">
                  <i className="ri-double-quotes-l text-sm" />
                </span>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}